import type { LocationsSearch } from "domains/admin/containers/LocationsDataGrid";
import { queries as locationsDataGridQueries } from "domains/admin/containers/LocationsDataGrid/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { search: LocationsSearch }): Array<WarmableQuery> => locationsDataGridQueries(input);
